// Action Types
const FETCH_CURRENT_PRODUCT_PENDING = "FETCH_CURRENT_PRODUCT_PENDING";
const FETCH_CURRENT_PRODUCT_SUCCESS = "FETCH_CURRENT_PRODUCT_SUCCESS";
const FETCH_CURRENT_PRODUCT_FAILURE = "FETCH_CURRENT_PRODUCT_FAILURE";
const CLEAR_CURRENT_PRODUCT = "CLEAR_CURRENT_PRODUCT"; // Optional: to clear data when exiting form

const initialState = {
    loading: false,
    data: null,
    error: null,
    requestedUuid: null,
};

const currentProductReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CURRENT_PRODUCT_PENDING:
            return {
                ...state,
                loading: true,
                data: null, // Optionally clear old data while loading new
                error: null,
                requestedUuid: action.requestedUuid ?? state.requestedUuid,
            };
        case FETCH_CURRENT_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
                requestedUuid: action.requestedUuid ?? state.requestedUuid,
            };
        case FETCH_CURRENT_PRODUCT_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
                requestedUuid: action.requestedUuid ?? state.requestedUuid,
            };
        case CLEAR_CURRENT_PRODUCT:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default currentProductReducer;
